import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-brand-ink text-white">
        <Loader2 className="h-8 w-8 animate-spin text-white" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
